import React from 'react'
import { Biometrics } from '@mobi/component-library/Signup/Biometrics'
import { routes } from '../Utils'
import { useHistory } from '../../../Hooks/useHistory'

export const BiometricsPage = () => {
  const appHistory = useHistory()
  return <Biometrics onSkip={() => appHistory.push(routes.depositLimit)} />
}
